import { autoinject, bindable, computedFrom, BindingEngine } from "aurelia-framework";
import { Location } from "../../models/location";
import { TreeView } from "../../aurelia-tree-view/tree-view/tree-view";
import * as Linq from "linq-es2015";
import { Property } from "../../models/property";
import { TreeNode } from "./tree-node";
import { Api } from "../../services/api";

@autoinject
export class NotificationRulesEditor {
	location: Location;
	tree: TreeView;
	selectedTitle: string;
	api: Api;
	active: boolean;
	bindingEngine: BindingEngine;

	treeNodes: any[];
	@bindable selectedNode: TreeNode;
	rules: Array<Property> = new Array<Property>();
	properties: Array<Property> = new Array<Property>(); 
	hasProperties: boolean = false;
	hasRules: boolean = false;
	hasNeitherPropertiesOrRules: boolean = false;
	hasSelectedNode: boolean = false;
	showAddDeviceButton: boolean = false;

	ruleChoices: Array<Property> = new Array<Property>();
	availableRuleChoices: Array<Property> = new Array<Property>();
	selectedRuleChoice: Property;

	subscription: any;

	constructor(api: Api, bindingEngine: BindingEngine) {
		this.api = api;
		this.bindingEngine = bindingEngine;
		this.createRuleChoices();
	} 

	createRuleChoices() {

		const batteryRule = new Property();
		batteryRule.name = "battery";
		batteryRule.type = "BatteryRule";
		this.ruleChoices.push(batteryRule);

		const rssiRule = new Property();
		rssiRule.name = "rssi";
		rssiRule.type = "RssiRule";
		this.ruleChoices.push(rssiRule);

		const temperatureRule = new Property();
		temperatureRule.name = "temperature";
		temperatureRule.type = "TemperatureRule";
		this.ruleChoices.push(temperatureRule);

		const weatherStationAirTemperatureRule = new Property();
		weatherStationAirTemperatureRule.name = "airTemperature";
		weatherStationAirTemperatureRule.type = "WeatherStationTemperatureRule";
		this.ruleChoices.push(weatherStationAirTemperatureRule);

		const waterLevelRule = new Property();
		waterLevelRule.name = "pressure";
		waterLevelRule.type = "WaterLevelRule";
		this.ruleChoices.push(waterLevelRule);

		const pipePressureRule = new Property();
		pipePressureRule.name = "pressure";
		pipePressureRule.type = "PipePressureRule";
		this.ruleChoices.push(pipePressureRule);
	}

	bind(bindingContext: any, overrideContext: any) {
		this.location = bindingContext.location;
	}

	async attached() {
		this.treeNodes = await this.getNodes();
		this.tree.dataSource.load(this.treeNodes);
		this.tree.dataSource.selectNode(this.treeNodes[0]);
		this.tree.dataSource.expandNode(this.tree.dataSource.nodes[0]);
	}

	onSelect(e) {
		this.selectedTitle = e.detail.nodes.map(node => node.payload.title).join(", ");
		this.processSelectedNode(e.detail.nodes[0].payload);
	}

	isType(type: string): boolean {
		if (this.selectedNode) {
			return this.selectedNode.type === type;
		}
		return false;
	}

	processSelectedNode(node: any) {

		if (this.subscription) {
			this.subscription.dispose();
		}

		this.selectedNode = node;
		this.subscription = this.bindingEngine.collectionObserver(this.selectedNode.properties).subscribe(properties => this.processSelectedNode(this.selectedNode));

		this.availableRuleChoices = this.ruleChoices.filter(choice => this.filterChoices(choice, this.selectedNode));
		this.selectedRuleChoice = null;

		if (this.selectedNode.type !== "DeviceTypes" && this.selectedNode.type !== "Root") {
			let propertiesEnumerable = Linq.AsEnumerable<Property>(this.selectedNode.properties);
			this.rules = propertiesEnumerable.Where(p => p.type.indexOf("Rule") > 0).ToArray();
			this.hasRules = this.rules.length > 0;

			propertiesEnumerable = Linq.AsEnumerable<Property>(this.selectedNode.properties);
			this.properties = propertiesEnumerable.Where(p => p.type === "Property").ToArray();
			this.hasProperties = this.properties.length > 0;

			this.hasNeitherPropertiesOrRules = !(this.hasProperties || this.hasRules);
			this.hasSelectedNode = true;
		} else {
			this.hasNeitherPropertiesOrRules = true;
			this.hasSelectedNode = false;
		}
		this.showAddDeviceButton = (this.selectedNode.type === "Structure");
	}

	async getNodes() {
		const nodes = [];
		this.active = true;
		const locationTreeNode = await this.api.getRulesTree(this.location.id);
		nodes.push(locationTreeNode);
		this.active = false;
		return nodes;
	}

	filterChoices(choice: Property, selectedNode: TreeNode) {
		if (selectedNode) {
			const properties = Linq.AsEnumerable<Property>(this.selectedNode.properties);
			return !properties.Any(p => p.type === choice.type);
		} else {
			return false;
		}
	}
	
	onAddTemperatureRuleDialogOpenStart($event) {
		this.selectedRuleChoice = null;
	}

	addRule() {
		this.selectedNode.properties.push(this.selectedRuleChoice);
		this.selectedRuleChoice = null;
	}

	onAddDeviceDialogOpenStart($event) {
		this.selectedRuleChoice = null;
	}

	async addDevice() {
		alert("Add device!");
	}
}
